import { useState } from "react";

/**
 * Manages a flat object of form field values, with helpers for wiring
 * an input's onChange directly or setting a field value programmatically.
 */

export function useFormFields(initial) {
    const [fields, setFields] = useState(initial);

    const set = (key) => (e) =>
        setFields((prev) => ({ ...prev, [key]: e.target.value }));

    const setField = (key, value) =>
        setFields((prev) => ({ ...prev, [key]: value }));

    return { fields, set, setField, setFields };
}
